import Content from './content'
import './style.css'

const Message = props => {
	if (!props.data) return null
	let cls = [
		'skin-message',
		'message'
	]
	cls = cls.join(' ')
	return (
		<div className={cls}>
			<div className='mess-shadow'></div>
			<Content data={props.data} />
		</div>
	)
}

export default Message
